import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Tabs, Typography, Spin, Row, Col, Input, message, Table, Icon, Button, Popconfirm, Form, Select } from 'antd'
import { Queries, Mutations } from '../../../../graphql'
import Container from '../../../../components/user/Container'
import FormHospital from '../../../../components/user/FormHospital'

const { TabPane } = Tabs
const { Text, Title } = Typography
const { Option } = Select;

const newsDataProfile = '';

class DashBoardStatus extends Component {
	state = {
        dataTalbe: [
			{
				key: '1',
				name: 'Mike',
				age: 32,
				address: '10 Downing Street',
			  },
			  {
				key: '2',
				name: 'John',
				age: 42,
				address: '10 Downing Street',
			  },
		],
        columns: [
            {
                title: 'ลำดับ',
                dataIndex: 'docId',
                width:'90px',
				align:'center',
                render: (item, record, index) => <span>{ (this.state.pageData.offset+index) + 1}</span>
            },
            {
                title: 'ชื่อสถานพยาบาล',
                dataIndex: 'docTitle',
                render: (item, record, index) => <span>{}</span>
            },
			{
                title: 'ประเภทสถานพยาบาล',
                dataIndex: 'docTitle',
                render: (item, record, index) => <span>{}</span>
            },
			{
                title: 'จังหวัด',
                dataIndex: 'docTitle',
                render: (item, record, index) => <span>{}</span>
            },
            {
                title: 'เขต/อำเภอ',
                dataIndex: 'docTitle',
                render: (item, record, index) => <span>{}</span>
            },
            {
                title: 'แขวง/ตำบน',
                dataIndex: 'docTitle',
                render: (item, record, index) => <span>{}</span>
            },
            {
                title: 'Action',
                dataIndex: '7',
                width:'120px',
				align:'center',
                render: (item, record, index) => {
                    return <>
						<Link
							to={{
								pathname: '/hospital/edit/1'
							}}
						>
                       	<Icon type="form" className="mr-2"/>
					   </Link>
					   <Popconfirm placement="topRight" title={"คุณต้องการที่จะลบ"} onConfirm={ () => this.delectField('1')} okText="ตกลง" cancelText="ยกเลิก">
						   <Icon type="delete"/>
						</Popconfirm>
                    </>
                }
            },
        ],
		pageData: {
            offset: 0,
            limit: 10
        },
        pagination: {
            total: 10,
        },
	}

    fetchData = async () =>{
        this.setState({
            dataForm:"1"
        })
    }

	onSubmit = async (values) => {
        const { form, afterSubmit, client } = this.props
        const { telNo, otpToken, refCode } = this.state
        window.location.href = '/hospital/Withdraw/1'

		// form.validateFields(async (err, values) => {
		// 	if (!err) {
        //         try {
                    
        //             const { data, errors } = await client.mutate({
        //                 mutation: Mutations.changePhoneNumber,
        //                 variables: {
        //                     telNo,
        //                     otp:{
        //                         otpToken: otpToken,
        //                         refCode: refCode,
        //                         otpCode: values.otp
        //                     }
        //                 }
        //             })

        //             console.log(data)

        //             if(data){
        //                 message.success("ส่งเพื่อดำเนินการเรียบร้อย")
        //                 setTimeout(() => {
        //                     window.location.reload();
        //                 }, 600);
        //             }
        //         }catch (error) {
                    
        //         }
		// 	}
		// })
	}

    
	async componentDidMount(){
        const { match, location } = this.props
        if(location.pathname.split('/')[3]){
            this.fetchData();
        }
        console.log(location.pathname.split('/')[3])
    }

	render() {
		const { match, location } = this.props
		const { dataTalbe, columns, loading, pagination } = this.state
		return (
			<Container match={match}>
				<div className="card-container" id="page-profile">
					<div className="px-5 py-1 card-bg-green">
						<Row gutter={16} type="flex" justify="left" align="top" className="box-color-white" >
							<Col xs={24} md={12} className="pt-2 mb-4">
								<strong className="color-red">
									ผลลัพธ์การค้นหา
								</strong>
							</Col>
							<Col xs={ 24 } md={24} >
								<Table
									dataSource={dataTalbe} 
									columns={columns} 
									loading={loading}
									pagination={pagination}
									onChange={this.paginationChange}
								/>
							</Col>
						</Row>
					</div>
				</div>
			</Container>
		)
	}
}

DashBoardStatus.defaultProps = {
	autoFocus: false
}

DashBoardStatus.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedDashBoardStatus = Form.create()(DashBoardStatus)

export default withApollo(WrappedDashBoardStatus)